/**
 * A document attached to a drone — registration papers, insurance, manuals,
 * maintenance records.
 *
 * Read-only on this portal. `adminOnly` rows are filtered out server-side, so
 * everything reaching here is shared with the operator; the field is kept on the
 * interface only because it comes down on the response.
 *
 * Mirrors the Hub's DroneResource model / adn_drone_resources table.
 */
export interface DroneResource {
  id: string;
  droneId: string;
  droneSource: 'adn' | 'organization';
  resourceType: string | null;

  fileName: string;
  fileSize: number | null;
  fileType: string | null;
  fileExtension: string | null;
  caption: string | null;

  s3Key: string;
  cdnUrl: string;

  adminOnly: boolean;

  uploadedByProfileId: string | null;
  createdAt: Date | string;
  updatedAt: Date | string;
}
